export const prefList = [
  {
    "pref_roma": "hokkaido",
    "pref_jp": "北海道"
  },
  {
    "pref_roma": "aomori",
    "pref_jp": "青森県"
  },
  {
    "pref_roma": "iwate",
    "pref_jp": "岩手県"
  },
  {
    "pref_roma": "miyagi",
    "pref_jp": "宮城県"
  },
  {
    "pref_roma": "akita",
    "pref_jp": "秋田県"
  },
  {
    "pref_roma": "yamagata",
    "pref_jp": "山形県"
  },
  {
    "pref_roma": "fukushima",
    "pref_jp": "福島県"
  },
  {
    "pref_roma": "ibaraki",
    "pref_jp": "茨城県"
  },
  {
    "pref_roma": "tochigi",
    "pref_jp": "栃木県"
  },
  {
    "pref_roma": "gunma",
    "pref_jp": "群馬県"
  },
  {
    "pref_roma": "saitama",
    "pref_jp": "埼玉県"
  },
  {
    "pref_roma": "chiba",
    "pref_jp": "千葉県"
  },
  {
    "pref_roma": "tokyo",
    "pref_jp": "東京都"
  },
  {
    "pref_roma": "kanagawa",
    "pref_jp": "神奈川県"
  },
  {
    "pref_roma": "niigata",
    "pref_jp": "新潟県"
  },
  {
    "pref_roma": "toyama",
    "pref_jp": "富山県"
  },
  {
    "pref_roma": "ishikawa",
    "pref_jp": "石川県"
  },
  {
    "pref_roma": "fukui",
    "pref_jp": "福井県"
  },
  {
    "pref_roma": "yamanashi",
    "pref_jp": "山梨県"
  },
  {
    "pref_roma": "nagano",
    "pref_jp": "長野県"
  },
  {
    "pref_roma": "gifu",
    "pref_jp": "岐阜県"
  },
  {
    "pref_roma": "shizuoka",
    "pref_jp": "静岡県"
  },
  {
    "pref_roma": "aichi",
    "pref_jp": "愛知県"
  },
  {
    "pref_roma": "mie",
    "pref_jp": "三重県"
  },
  {
    "pref_roma": "shiga",
    "pref_jp": "滋賀県"
  },
  {
    "pref_roma": "kyoto",
    "pref_jp": "京都府"
  },
  {
    "pref_roma": "osaka",
    "pref_jp": "大阪府"
  },
  {
    "pref_roma": "hyogo",
    "pref_jp": "兵庫県"
  },
  {
    "pref_roma": "nara",
    "pref_jp": "奈良県"
  },
  {
    "pref_roma": "wakayama",
    "pref_jp": "和歌山県"
  },
  {
    "pref_roma": "tottori",
    "pref_jp": "鳥取県"
  },
  {
    "pref_roma": "shimane",
    "pref_jp": "島根県"
  },
  {
    "pref_roma": "okayama",
    "pref_jp": "岡山県"
  },
  {
    "pref_roma": "hiroshima",
    "pref_jp": "広島県"
  },
  {
    "pref_roma": "yamaguchi",
    "pref_jp": "山口県"
  },
  {
    "pref_roma": "tokushima",
    "pref_jp": "徳島県"
  },
  {
    "pref_roma": "kagawa",
    "pref_jp": "香川県"
  },
  {
    "pref_roma": "ehime",
    "pref_jp": "愛媛県"
  },
  {
    "pref_roma": "kouchi",
    "pref_jp": "高知県"
  },
  {
    "pref_roma": "fukuoka",
    "pref_jp": "福岡県"
  },
  {
    "pref_roma": "saga",
    "pref_jp": "佐賀県"
  },
  {
    "pref_roma": "nagasaki",
    "pref_jp": "長崎県"
  },
  {
    "pref_roma": "kumamoto",
    "pref_jp": "熊本県"
  },
  {
    "pref_roma": "oita",
    "pref_jp": "大分県"
  },
  {
    "pref_roma": "miyazaki",
    "pref_jp": "宮崎県"
  },
  {
    "pref_roma": "kagoshima",
    "pref_jp": "鹿児島県"
  },
  {
    "pref_roma": "okinawa",
    "pref_jp": "沖縄県"
  }
]

export const prefTranslater = {
  "hokkaido": "北海道",
  "aomori": "青森県",
  "iwate": "岩手県",
  "miyagi": "宮城県",
  "akita": "秋田県",
  "yamagata": "山形県",
  "fukushima": "福島県",
  "ibaraki": "茨城県",
  "tochigi": "栃木県",
  "gunma": "群馬県",
  "saitama": "埼玉県",
  "chiba": "千葉県",
  "tokyo": "東京都",
  "kanagawa": "神奈川県",
  "niigata": "新潟県",
  "toyama": "富山県",
  "ishikawa": "石川県",
  "fukui": "福井県",
  "yamanashi": "山梨県",
  "nagano": "長野県",
  "gifu": "岐阜県",
  "shizuoka": "静岡県",
  "aichi": "愛知県",
  "mie": "三重県",
  "shiga": "滋賀県",
  "kyoto": "京都府",
  "osaka": "大阪府",
  "hyogo": "兵庫県",
  "nara": "奈良県",
  "wakayama": "和歌山県",
  "tottori": "鳥取県",
  "shimane": "島根県",
  "okayama": "岡山県",
  "hiroshima": "広島県",
  "yamaguchi": "山口県",
  "tokushima": "徳島県",
  "kagawa": "香川県",
  "ehime": "愛媛県",
  "kouchi": "高知県",
  "fukuoka": "福岡県",
  "saga": "佐賀県",
  "nagasaki": "長崎県",
  "kumamoto": "熊本県",
  "oita": "大分県",
  "miyazaki": "宮崎県",
  "kagoshima": "鹿児島県",
  "okinawa": "沖縄県",
  "北海道": "hokkaido",
  "青森県": "aomori",
  "岩手県": "iwate",
  "宮城県": "miyagi",
  "秋田県": "akita",
  "山形県": "yamagata",
  "福島県": "fukushima",
  "茨城県": "ibaraki",
  "栃木県": "tochigi",
  "群馬県": "gunma",
  "埼玉県": "saitama",
  "千葉県": "chiba",
  "東京都": "tokyo",
  "神奈川県": "kanagawa",
  "新潟県": "niigata",
  "富山県": "toyama",
  "石川県": "ishikawa",
  "福井県": "fukui",
  "山梨県": "yamanashi",
  "長野県": "nagano",
  "岐阜県": "gifu",
  "静岡県": "shizuoka",
  "愛知県": "aichi",
  "三重県": "mie",
  "滋賀県": "shiga",
  "京都府": "kyoto",
  "大阪府": "osaka",
  "兵庫県": "hyogo",
  "奈良県": "nara",
  "和歌山県": "wakayama",
  "鳥取県": "tottori",
  "島根県": "shimane",
  "岡山県": "okayama",
  "広島県": "hiroshima",
  "山口県": "yamaguchi",
  "徳島県": "tokushima",
  "香川県": "kagawa",
  "愛媛県": "ehime",
  "高知県": "kouchi",
  "福岡県": "fukuoka",
  "佐賀県": "saga",
  "長崎県": "nagasaki",
  "熊本県": "kumamoto",
  "大分県": "oita",
  "宮崎県": "miyazaki",
  "鹿児島県": "kagoshima",
  "沖縄県": "okinawa"
}

